import { UserServiceClient } from 'fitbeat.api-clients';
import { FamilyPlanConfig } from 'fitbeat.gym-core';
import React from 'react';
import { translate } from 'react-i18next';
import { Keyboard,  StyleSheet , Text, TouchableWithoutFeedback, View } from 'react-native';
import SmoothPinCodeInput from 'react-native-smooth-pincode-input';
import { connect } from 'react-redux';
import { Button } from '../components';
import { getApiConfig } from '../config/index';
import theme from '../theme';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { defaultScale, scaleText } from '../utils/scaling';
import { updateUserProfilePin } from './actions';
import { ISwitchMemberUserProfile } from './reducer';
import { activeFamilyMemberSelector, isProfilePinChangeLoadingSelector, memberHasPinSelector } from './selector';
interface IProps {
    activeFamilyMember: ISwitchMemberUserProfile;
    navigation: any;
    isProfilePinChangeLoading: boolean;
    t: (s: string) => string;
    userUpdatedPin: (pin: string, uid: string) => void;
    memberHasPin: boolean;
}

interface IState {
    code: string;
}

class SetProfilePinComponent extends React.PureComponent<IProps, IState> {
  private pinInput;
  constructor(props) {
    super(props);
    this.pinInput = React.createRef();
    this.state = {
      code: '',
    };
  }

  public render() {
    const { t, isProfilePinChangeLoading, memberHasPin} = this.props;
    return (
      <TouchableWithoutFeedback onPress={Keyboard.dismiss} >
        <View style={styles.container}>
          <View style={styles.pinContainer}>
            <Text style={styles.setPinText}>
              {memberHasPin ? t('setProfilePin') : t('setProfilePinOptional')}
            </Text>
            <View style={styles.textInputContainerStyle}>
              <SmoothPinCodeInput
                ref={this.pinInput}
                cellStyle={{
                  borderBottomWidth: 1,
                  borderColor: theme.GREY_MEDIUM_LIGHT,
                }}
                cellStyleFocused={{
                  borderColor: theme.GREY_MEDIUM,
                }}
                value={this.state.code}
                cellSpacing={10}
                onTextChange={(code) => this.setState({ code })}
                animated={false}
                textStyle={styles.textInputStyle}
                mask={<Text style={styles.textInputStyle}>*</Text>}
                maskDelay={500}
                password={true}
                keyboardType={'decimal-pad'}
                codeLength={FamilyPlanConfig.pinLength}
                restrictToNumbers={true}
                autoFocus={true}
                onFulfill={Keyboard.dismiss}
              />
            </View>
            <Text style={theme.textStyle.bodyCopyReg}>
              {t('youWillBeAskedToEnterYourPin')}
            </Text>
          </View>
        <Button
          title={t('Save')}
          overrideFontStyles={styles.buttonText}
          onPress={this.changeProfilePin}
          isLoading={isProfilePinChangeLoading}
          disabled={this.state.code.length !== FamilyPlanConfig.pinLength}
        />
        </View>
      </TouchableWithoutFeedback>
    );
  }

  private changeProfilePin =  async () => {
    const { userUpdatedPin, activeFamilyMember, navigation } = this.props;
    await userUpdatedPin(this.state.code, activeFamilyMember.uid);
    navigation.pop();
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: defaultScale(15),
    backgroundColor: theme.WHITE,
  },
  textInputStyle: {
    fontFamily: theme.Custom700,
    fontSize: 36,
    color: theme.BLACK,
  },
  textInputContainerStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 28,
    borderColor: '#D6D6D6',
    borderWidth: 1,
    marginBottom: defaultScale(21),
  },
  setPinText: {
    fontFamily: theme.Custom700,
    fontSize: scaleText(16),
    color: theme.BLACK,
    marginBottom: defaultScale(3),
  },
  buttonText: {
    fontFamily: theme.Custom700,
    fontSize: scaleText(16),
    color: theme.WHITE,
  },
  pinContainer: {
    flex: 1,
    justifyContent: 'center',
  },
});

const mapStateToProps = (state: any) => {
  return {
    activeFamilyMember: activeFamilyMemberSelector(state),
    isProfilePinChangeLoading: isProfilePinChangeLoadingSelector(state),
    memberHasPin: memberHasPinSelector(state),
  };
};

const mapDispatchToProps = ( dispatch: any ) => {
  const userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder());
  return {
    userUpdatedPin: (pin: string, uid: string) =>
      dispatch(updateUserProfilePin(userServiceClient, pin, uid)),
  };
};
export const SetProfilePin = translate(['familyPlan'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(SetProfilePinComponent),
);
